import { OrderByDirection, type Backend } from '@freelancer/datastore/core';
import type { ServiceOfferingAttachmentsCollection } from './service-offering-attachments.types';

export function serviceOfferingAttachmentBackend(): Backend<ServiceOfferingAttachmentsCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: undefined,
    push: (authUid, document, original) => {
      return {
        endpoint: `service_offerings/0.1/service_offerings/${document.id}/attachments_new`,
        method: 'POST',
        payload: {
          id: document.id,
          uuids: document.uuids,
        },
      };
    },
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
